package org.catharsis.spendtel.feature.data

import dev.gitlive.firebase.auth.FirebaseUser
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
fun FirebaseUser.toSpendtelUser(): SpendtelUser {
    return authUserToSpendtelUser(
        uid = uid,
        email = email,
        photoUrl = photoURL,
    )
}
